export default __webpack_public_path__ + "static/1-418c795a00f7d69c4f0966a0973abaed.png";